module.exports = __webpack_public_path__ + "img/seal2.ccce4bdb.png";